import React from 'react';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {buildEntrySearchByForm, searchByParams} from './../../search/lib/search';
import './typehead.css';
import {AdministrationUtilities} from "../../administration/AdministrationHelper";
import Dict from 'dict-lib';

export class EntryTypeahead extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            align: 'justify',
            printSettings: {entryAtFirstPlace: true, sep: '', sepStyle: {}},
            items: [],
            languageId: this.props.languageId,
            selected: this.props.selected,
            options: [],
            query: ''
        };

        this.hasCallbackParentSearchOn = typeof this.props.callbackParentSearchOn !== 'undefined';
        this.isGlossary = AdministrationUtilities.isGlossary();


        this._handleSearch = this._handleSearch.bind(this);
        this._handleChange = this._handleChange.bind(this);
        this._handleOnInputChange = this._handleOnInputChange.bind(this);
    }

    componentWillMount() {
        this.setState({host: this.props.host});
    }

    componentDidMount() {
        if (typeof this.props.preset !== 'undefined') {
            this._handleSearch(this.props.preset);
            this._resetPrintSettings(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        const languageId = nextProps.languageId;
        if (typeof this.props.searchParams !== 'undefined' && ((typeof languageId !== 'undefined' && languageId !== this.state.languageId) || (typeof this.props.searchParams !== 'undefined' && (this.props.searchParams.className !== nextProps.searchParams.className || (this.props.searchParams.type !== nextProps.searchParams.type))))) {
            var options = [];
            var items = [];
            this._resetPrintSettings(nextProps);
            if (nextProps.searchParams.type === this.props.searchParams.type) {
                this.refs.entrytypeahead.getInstance().clear();
            } else {
                this._handleSearch(this.state.query, nextProps.searchParams);
            }
            this.setState({languageId, options, items}, function () {
                this.refs.entrytypeahead.getInstance().focus();
                document.getElementsByTagName('input')[0].click();
            });
        } else if (nextProps.forceFocus) {
            this.refs.entrytypeahead.getInstance().focus();
        } else if (nextProps.host) {
            this.setState({host: nextProps.host, languageId})
        }
    }

    _checkFocusSearch(newState) {
        if (typeof this.refs !== 'undefined' && typeof this.refs.entrytypeahead !== 'undefined' && this.refs.entrytypeahead.getInstance() !== null) {
            this.refs.entrytypeahead.getInstance().focus();
            if (this.state.query)
                this._handleSearch(this.state.query);
        }
    }

    _getTopicDescription(topicIds) {
        return AdministrationUtilities.printTopics(topicIds);
    }

    _resetPrintSettings(props) {
        var printSettings = this.state.printSettings;
        if(typeof props.searchParams !== 'undefined' && typeof props.searchParams.className !== 'undefined') {
            printSettings.entryAtFirstPlace = props.searchParams.className !== 'DeclinedForm';
            printSettings.sep = props.searchParams.className === 'DeclinedForm' || props.searchParams.className === 'Dictionary' ? '▶' : props.searchParams.className === 'Entry' ? '' : '◀';
            printSettings.sepStyle = props.searchParams.className !== 'Entry' ? {marginRight: '6px'} : {};
            this.setState({printSettings});
        }
    }

    _handleSearch(query, searchParams) {
        if (!query) {
            return;
        } else {
            searchParams = typeof searchParams !== 'undefined' ? searchParams : this.props.searchParams
            var promise = typeof searchParams !== 'undefined' ? searchByParams(searchParams) : buildEntrySearchByForm(query + "*", this.state.languageId, this.state.host, this.props.classType, this.props.includeAlternativeForms);

            promise.then(result => {
                const items = result.items;
                var options = [];
                if (items.length > 0) {
                    items.map(item => {
                        var id, label, highlightLabel, abstr, homographic, polyId, senseId, topic = null;
                        if (item.type === 'EntryItem') {
                            var idField = typeof this.props.fieldIdName === 'undefined' ? 'id' : this.props.fieldIdName;
                            id = item.fields[idField];
                            label = item.fields.entryForm;
                            highlightLabel = null;
                            abstr = item.fields.abstr;
                            homographic = item.fields.homographic;
                            polyId = item.fields.polyId;
                            senseId = item.fields.semanticUnitId;
                        } else {
                            id = item.fields.id;
                            label = item.fields.phraseText.replace('<hightlight-search-result>', '').replace('</hightlight-search-result>', '');
                            highlightLabel = item.fields.phraseText;
                            abstr = item.fields.lexemes.length === 0 ? '' : "- " + item.fields.lexemes.map((item) => {
                                return item.label;
                            }).join(', ');
                            homographic = '';
                        }

                        topic = this.isGlossary ? this._getTopicDescription(item.fields.topics) : '';


                        options.push({
                            id: id,
                            label: label,
                            highlightLabel: highlightLabel,
                            abstr: abstr,
                            homographic: homographic,
                            polyId: polyId,
                            senseId: senseId,
                            topic: topic,
                            type: item.fields.subType
                        });
                    });
                }

                if (typeof this.state.host !== 'undefined' && this.state.host.length > '') {
                    this.props.callbackParentSearchOn(true, items.length > 0, query);
                }

                this.setState({options, query});
            });
        }
    }

    _handleOnInputChange(text) {
        var options = [];
        this.setState({options});

        if (this.hasCallbackParentSearchOn)
            this.props.callbackParentSearchOn(text.length > 0, false, text);
    }

    _handleChange(item) {
        if (Object.keys(item).length > 0) {
            this.setState({
                value: item[0].id
            });
            this.props.callbackParent(item[0]);
            if (this.hasCallbackParentSearchOn && typeof this.props.searchParams === 'undefined')
                this.props.callbackParentSearchOn(true, true, item[0].label);
        } else {
            this.props.callbackParent("");
            if (this.hasCallbackParentSearchOn)
                this.props.callbackParentSearchOn(false, false, '');
        }
    }

    _handleKeyDown(evt) {
        if (this.props.enableEnter && evt.keyCode === 13) {
            this.props.callbackParentPressEnter();
        }
    }

    render() {
        const {align} = this.state;
        var chooseLanguage = typeof this.props.placeholder !== 'undefined' ? this.props.placeholder : "entry...";

        return (
            <AsyncTypeahead
                defaultSelected={typeof this.props.preset !== 'undefined' ? [this.props.preset] : []}
                ref={"entrytypeahead"}
                minLength={1}
                maxResult={10}
                className={`entry-typeahead ${typeof this.props.className === 'undefined' ? '' : this.props.className}`}
                clearButton
                autoFocus={true}
                align={align}
                ignoreDiacritics
                filterBy={(option, props) => {
                    return true;
                }}
                emptyLabel
                onKeyDown={evt => this._handleKeyDown(evt)}
                onChange={item => this._handleChange(item)}
                onSearch={this._handleSearch}
                onInputChange={this._handleOnInputChange}
                onFocus={this.props.resetSearchOnFocus ? (newState) => this._checkFocusSearch(newState) : this.props.onFocus}
                options={this.state.options}
                placeholder={chooseLanguage}
                useCache={typeof this.props.useCache !== 'undefined' ? this.props.useCache : true}
                renderMenuItemChildren={(option, props) => {
                    const entryAtFirstPlace = option.type !== 'POLYRHEMATIC' && option.type !== 'DECLINED_FORM';
                    var supHomo = typeof option.homographic !== 'undefined' && option.homographic !== '0' ?
                        <sup style={{marginRight: '6px'}}>{option.homographic}</sup> : '';
                    const retVal = <>
                        <strong style={{
                            marginRight: supHomo !== '' && entryAtFirstPlace ? '0' : '6px',
                            textAlign: 'right',
                            fontStyle: ((option.id + '').startsWith('external') ? 'italic' : 'normal')
                        }}
                                dangerouslySetInnerHTML={{__html: option.highlightLabel !== null ? option.highlightLabel : option.label}}/>
                        {entryAtFirstPlace ? supHomo : ''}
                        {option.topic.length > 0 ? <small style={{marginRight: '4px', color: '#00007AEC'}}
                                                          dangerouslySetInnerHTML={{__html: option.topic}}/> : ''}
                        <><small
                            style={this.state.printSettings.sepStyle}>{option.type === 'ENTRY' ? '' : this.state.printSettings.sep}</small><small
                            dangerouslySetInnerHTML={{__html: option.abstr}}/>{entryAtFirstPlace ? '' : supHomo}</>
                    </>

                    if (typeof this.props.searchParams !== 'undefined' && this.props.searchParams.className === 'Dictionary') {
                        return (
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                                <span style={{flex: 1}}>{retVal}</span>
                                <small style={{color: '#265a88', marginLeft: '10px', whiteSpace: 'nowrap', fontSize: '11px', textAlign: 'left', fontVariant: 'small-caps', fontWeight: 'bold'}}>[{Dict.t(option.type)}]</small>
                            </div>
                        );
                    } else {
                        return retVal;
                    }
                }
                }
            />
        );
    }
}



